import React from 'react'

const ProjGalBanner = () => {
  return (
    <div className='flex items-center justify-center h-1/6'>
        <h1 className='font-display font-medium text-2xl text-navy p-4'>
            Discover our complete project gallery&nbsp; 
            <a href="/projects"><button className='font-bold underline'>here.</button></a>
        </h1>
    </div>
  )
}

export default ProjGalBanner